import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AssociateDishModal from './AssociateDishModal';
import { setPaymentAssociations } from '../../stateManagement/engine/actions/OrderActions';
import _ from 'lodash';

function mapStateToProps(state, ownProps) {
  return {
    orderItems: state.order.orderItems,
    payments: state.checkout.payments,
    itemsHash: state.session.itemsHash,
    currency: state.session.organization.currency,
    locale: state.session.organization.locale,
    i18n: { get: str => str },
    ppd: state.order.paymentAssociations,
    paymentIndex: state.session.associateDishPaymentIndex,
    collectionMethod: _.get(state, 'session.organization.creditcardsInfo.collectionMethod'),
    onCloseClick: () => {},
    onChange: () => {},
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setPaymentAssociations,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssociateDishModal);
